import { createFileRoute } from '@tanstack/react-router';
import AddCandidatesDialog from '../../../../Components/AddCandidatesDialog';

export const Route = createFileRoute('/(main)/_layout/candidates/_candidates/new')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AddCandidatesDialog />;
}
